import React, {useEffect} from 'react';

import classNames from 'classnames';
import {useInView} from 'react-intersection-observer';
import {connect} from 'react-redux';

import {TYP_UPSELL_TYPES} from 'constants/product';
import {ApplicationStoreType} from 'desktop/store';

import {FrameDetailsType} from '../../types/types';
import {UpsellAccessoryType} from '../../types/upsellsTypes';

import s from './upsellItemWrapper.scss';

export type PropsType = {
    upsell: UpsellAccessoryType;
    frames: Array<FrameDetailsType>;
    children: React.ReactNode;
    onView: (upsell: UpsellAccessoryType) => void;
};

/**
 * Upsell item wrapper with analytic classes
 * @param {PropsType} props - Component props
 * @returns {Node} - Rendered upsell item wrapper with analytic classes
 */
export const UpsellItemWrapper = ({children, frames, onView, upsell}: PropsType) => {
    const {inView, ref} = useInView({
        threshold: 1,
        triggerOnce: true,
    });
    useEffect(() => {
        if (inView) onView(upsell);
    }, [inView]);
    const {color_name: colorName, title, type} = upsell;
    const classes = frames.reduce(
        (accumulator: Record<string, boolean>, frame: FrameDetailsType) => ({
            ...accumulator,
            [`${frame.lensType}-typ`]: true,
            [`frame-${frame.isPremium ? '' : 'non'}premium-typ`]: true,
        }),
        {},
    );

    if (type === TYP_UPSELL_TYPES.ACCESSORY) {
        classes[
            `${title.split(' ').join('-').toLowerCase()}-${
                colorName ? colorName.toLowerCase() : 'uncolored'
            }-typ`
        ] = true;
    }

    return (
        <li
            className={classNames(s.item, Object.keys(classes))}
            data-exp={type === TYP_UPSELL_TYPES.ACCESSORY ? 'accessory' : 'upsell'}
            ref={ref}
        >
            {children}
        </li>
    );
};

/**
 * Map state to props
 * @param {ApplicationStoreType} store - redux store
 * @returns {PropsType} props
 */
const mapStateToProps = (
    state: ApplicationStoreType,
): {
    frames: Array<FrameDetailsType>;
} => ({
    frames: state.successPage.order.frames,
});
export const UpsellItemWrapperConnected = connect(mapStateToProps)(UpsellItemWrapper);
